// Use relative URL in production or when accessed via domain (via nginx proxy), absolute URL for localhost development
const isProduction = import.meta.env.PROD;
const isDomainAccess = typeof window !== 'undefined' && 
  window.location.hostname !== 'localhost' && 
  window.location.hostname !== '127.0.0.1';

export const API_BASE_URL = import.meta.env.VITE_API_URL || 
  (isProduction || isDomainAccess ? '/api' : 'http://localhost:8888/api');

export const API_ENDPOINTS = {
  POSTS: '/posts',
  POST_BY_ID: (id: string) => `/posts/${id}`,
  POST_COMMENTS: (postId: string) => `/posts/${postId}/comments`,
  COMMENT_BY_ID: (id: string) => `/comments/${id}`,
  // Moderation endpoints (Iteration 5)
  MODERATION_POST_DELETE: (id: string) => `/moderation/posts/${id}/delete`,
  MODERATION_POST_RESTORE: (id: string) => `/moderation/posts/${id}/restore`,
  MODERATION_POST_EDIT_HISTORY: (id: string) => `/moderation/posts/${id}/edit-history`,
  MODERATION_FLAGGED_POSTS: '/moderation/flagged-posts',
  MODERATION_APPROVE_FLAG: (id: string) => `/moderation/flagged-posts/${id}/approve`,
  MODERATION_REJECT_FLAG: (id: string) => `/moderation/flagged-posts/${id}/reject`,
  MODERATION_FLAGGED_COMMENTS: '/moderation/flagged-comments',
  MODERATION_APPROVE_COMMENT_FLAG: (id: string) => `/moderation/flagged-comments/${id}/approve`,
  MODERATION_REJECT_COMMENT_FLAG: (id: string) => `/moderation/flagged-comments/${id}/reject`,
} as const;

